import { useEffect } from "react";

function GoogleTagManager({ configCode, isDidomiReady }) {
  useEffect(() => {
    if (!isDidomiReady) return; // Wait for Didomi to be ready

    let gtmId = "GTM-5JFTM9M7"; // FR
    if (configCode === "onair.es") {
      gtmId = "GTM-N5GCSLP7"; // ES
    } else if (configCode === "onair.ma") {
      gtmId = "GTM-KB7HMM4R"; // MA
    }

    // Initialisation de dataLayer
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      "gtm.start": new Date().getTime(),
      event: "gtm.js",
    });

    // Ajout du script GTM
    const script = document.createElement("script");
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtm.js?id=${gtmId}&l=dataLayer`;

    const firstScript = document.getElementsByTagName("script")[0];
    firstScript.parentNode.insertBefore(script, firstScript);

    // Ajout d'une catégorie de page
    window.dataLayer.push({
      page_category: "Funnel",
    });
  }, [configCode, isDidomiReady]);

  return null; // Pas de rendu visuel
}

export default GoogleTagManager;
